import * as React from 'react';
import { useSelector } from 'react-redux';
import { getUser } from '../../selectors/analytics';
import { getBuilder, getGaLabel, getName, getNewbuildingId, getTimezone } from '../../selectors/newbuilding';
import { getCallbackRecommendations } from '../../selectors/requestCallback';
import { getUserPhone } from '../../selectors/user';
import { TRequestCallbackOpener } from '../../types/microfrontends/newbuildingCallbackWidget';
import { getPhoneString } from '../../utils/text';
import { NewbuildingCallbackWidgetContext } from '../NewbuildingCallbackWidgetProvider';

export function useCallbackButton(placeType: TRequestCallbackOpener): [boolean, () => void, boolean] {
  const [isLoading, setLoading] = React.useState(false);

  const builder = useSelector(getBuilder);
  const gaLabel = useSelector(getGaLabel);
  const user = useSelector(getUser);
  const userPhoneNumber = useSelector(getUserPhone);
  const timezoneOffset = useSelector(getTimezone);
  const newbuildingName = useSelector(getName);
  const newbuildingId = useSelector(getNewbuildingId);
  const recommendations = useSelector(getCallbackRecommendations);

  const openWidget = React.useContext(NewbuildingCallbackWidgetContext);

  const callbackPhone = builder ? getPhoneString(builder.phone) : null;
  const isAvailable = !!callbackPhone;

  const handleClick = React.useCallback(async () => {
    if (!callbackPhone) {
      return;
    }

    setLoading(true);

    await openWidget({
      agentPhone: callbackPhone,
      timezoneOffset,
      userPhoneNumber,
      builderRealtyUserId: builder.realtyUserId,
      newbuildingName,
      recommendations,
      newbuildingId,
      callbackButtonText: 'Заказать',
      trackingParams: {
        category: 'CardJK',
        opener: placeType,
        gaLabel,
        user,
      },
    });

    setLoading(false);
  }, [
    callbackPhone,
    timezoneOffset,
    userPhoneNumber,
    builder,
    newbuildingName,
    recommendations,
    newbuildingId,
    gaLabel,
    placeType,
    user,
    openWidget,
  ]);

  return [isAvailable, handleClick, isLoading];
}
